import { CardShell } from '@/components/cards/common';
import { Icon } from '@acast-tech/decibel';
import { CheckRegularGlyph } from '@acast-tech/decibel-glyphs';

export const NoPayoutYetCard = () => {
  return (
    <CardShell className="col-span-12 h-full">
      <div className="flex flex-col gap-6 max-w-[616px] mx-auto">
        <div className="flex justify-center ">
          <img src="/time.png" width="63" />
        </div>
        <h3 className="text-[28px] font-bold text-center font-telegraf">No payout yet</h3>
        <div className="flex flex-col leading-[24px] text-textDarkGrey text-sm">
          <p>
            You'll receive a self-bill or statement around the middle of the month, provided that:
          </p>
          <br />
          <p>
            <Icon glyph={CheckRegularGlyph} primaryColor="#4040A8" />{' '}
            <strong>You enter your details and select your preferred payment method</strong> through
            our payment platform, Tipalti.
          </p>
          <p>
            <Icon glyph={CheckRegularGlyph} primaryColor="#4040A8" />{' '}
            <strong>Your verified unpaid earnings exceed €100</strong> (or approximate equivalent in
            your currency).
          </p>
          <p>
            The balance will roll over to the next payout month if payable earnings do not meet this
            threshold.{' '}
            <a
              href="https://learn.acast.com/en/articles/5146617-when-will-i-get-paid"
              target="_blank"
              className="underline"
            >
              Learn more
            </a>
          </p>
        </div>
        <div className="flex p-4 flex-col justify-center items-start gap-2 flex-1 rounded-lg bg-[#F8F8FC] text-textDarkGrey text-sm">
          <h5 className="text-[#4040A8] text-[11px] font-normal leading-normal tracking-[1.5px] uppercase font-semibold inline-flex items-center gap-2">
            <FontAwesomeLightBulb /> Choose your payment method now
          </h5>
          <p>To ensure seamless payments, make sure your Tipalti account is set up.</p>
          <a
            href="https://learn.acast.com/en/articles/8538524-what-is-tipalti"
            target="_blank"
            className="underline"
          >
            How to set up your Tipalti account
          </a>
        </div>
      </div>
    </CardShell>
  );
};

const FontAwesomeLightBulb = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" className="w-4 h-4">
      {/* <!--!Font Awesome Pro 7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--> */}
      <path
        d="M480 256C480 298.7 463.3 337.4 436.1 366.1C416.2 387 395.7 414.8 387.6 448L252.4 448C244.3 414.7 223.8 387 203.9 366.1C176.7 337.4 160 298.7 160 256C160 167.6 231.6 96 320 96C408.4 96 480 167.6 480 256zM256 480L384 480L384 496C384 522.5 362.5 544 336 544L304 544C277.5 544 256 522.5 256 496L256 480zM416 477.7C416 443.4 435.7 413 459.3 388.1C492 353.7 512 307.2 512 256C512 150 426 64 320 64C214 64 128 150 128 256C128 307.2 148 353.7 180.7 388.1C204.3 413 224 443.4 224 477.7L224 496C224 540.2 259.8 576 304 576L336 576C380.2 576 416 540.2 416 496L416 477.7zM304 176C312.8 176 320 168.8 320 160C320 151.2 312.8 144 304 144C251 144 208 187 208 240C208 248.8 215.2 256 224 256C232.8 256 240 248.8 240 240C240 204.7 268.7 176 304 176zM40.9 82.7C33.5 77.8 23.6 79.8 18.7 87.1C13.8 94.4 15.8 104.4 23.1 109.3L71.1 141.3C78.5 146.2 88.4 144.2 93.3 136.9C98.2 129.6 96.2 119.6 88.9 114.7L40.9 82.7zM616.9 109.3C624.3 104.4 626.2 94.5 621.3 87.1C616.4 79.7 606.5 77.8 599.1 82.7L551.1 114.7C543.7 119.6 541.8 129.5 546.7 136.9C551.6 144.3 561.5 146.2 568.9 141.3L616.9 109.3zM16 240C7.2 240 0 247.2 0 256C0 264.8 7.2 272 16 272L64 272C72.8 272 80 264.8 80 256C80 247.2 72.8 240 64 240L16 240zM576 240C567.2 240 560 247.2 560 256C560 264.8 567.2 272 576 272L624 272C632.8 272 640 264.8 640 256C640 247.2 632.8 240 624 240L576 240zM88.9 397.3C96.3 392.4 98.2 382.5 93.3 375.1C88.4 367.7 78.5 365.8 71.1 370.7L23.1 402.7C15.7 407.6 13.8 417.5 18.7 424.9C23.6 432.3 33.5 434.2 40.9 429.3L88.9 397.3zM568.9 370.7C561.5 365.8 551.6 367.8 546.7 375.1C541.8 382.4 543.8 392.4 551.1 397.3L599.1 429.3C606.5 434.2 616.4 432.2 621.3 424.9C626.2 417.6 624.2 407.6 616.9 402.7L568.9 370.7z"
        fill="currentcolor"
      />
    </svg>
  );
};
